import CategoriesPicker from './CategoriesPicker';
export default CategoriesPicker;
